import React, {PropTypes, Component} from 'react';
import {I18N, CONFIG} from '../../../globals/config';

const api = CONFIG.api + 'join_modal/';

class PartTwo extends Component {
	constructor( props ){
		super( props );

		this.state = {
			cell_number : "",
			daily : true,
			monthly : true,
			text : CONFIG.is_sms_active,
			phone_error : false,
		};

		_.bindAll( this, 'onChange', '_save_settings' );
	}


	onChange( event ){
		if( event.target.type == "checkbox" ){
			this.state[event.target.name] = event.target.checked ? 1 : 0;
		} else {
			if( event.target.name == 'cell_number' ){
				this.state[event.target.name] = event.target.value.replace(/\D/g,'');
			} else {
				this.state[event.target.name] = event.target.value;
			}
		}

		this.setState( this.state );
	}

	_save_settings( event ){
		var data    = this.state;
		data.method = 'save_account_settings';
		if( this.state.text && _.isEmpty( this.state.cell_number ) ){
			this.setState({
				phone_error : true
			});
		} else {
			//send data
			$.post( api, data, function(){});

			//if we didn't open for login go to next step -> else reload page
			//https://docs.google.com/document/d/1H9TjEPKUFT_bLCWJfPxK1ewEn0L-Z63toruakogPEgY/edit#bookmark=id.4rlft45ypepo
			if( !this.props.open_with_login ){
				this.props.changeStep( event );
			} else {
				window.location.reload();
			}
		}
	}


	componentDidMount(){
		$( '.phone_mask' ).inputmask( {
			mask : "(999) 999-9999",
			onKeyDown : this.onChange
		});
	}


	render(){
		return (
			<div className="form-wrap">
				<p>
					{I18N.subscriptions.never_miss}
				</p>
				<ul>
					<li>
						<input type="checkbox" name="daily" defaultChecked="checked" value="1" onClick={this.onChange}/>
						<label htmlFor="daily">
							{I18N.subscriptions.daily_activity}
						</label>
					</li>
					<li>
						<input type="checkbox" name="monthly" defaultChecked="checked" value="1" onClick={this.onChange}/>
						<label htmlFor="monthly">
							{I18N.subscriptions.monthly_activity}
						</label>
					</li>
					{CONFIG.is_sms_active && <li>
						<input type="checkbox" name="text" defaultChecked="checked" value="1" onClick={this.onChange}/>
						<label htmlFor="text">
							{I18N.subscriptions.text_message}
						</label>
						<p>
							{this.state.phone_error && <span className="error">{I18N.subscriptions.phone_error}</span>}
							<input className="phone phone_mask" type="tel" name="cell_number" placeholder={I18N.subscriptions.enter_phone} value={this.state.cell_number} onChange={this.onChange}/>
						</p>
					</li>
					}
				</ul>

				<input
					className="button button-primary"
					type="submit"
					name="join-submit"
					value={I18N.next}
					onClick={this._save_settings.bind( this )}
					data-step="3"
				/>
			</div>
		)
	}
}

PartTwo.propTypes = {
	changeStep : PropTypes.func.isRequired,
	first_name : PropTypes.string.isRequired,
};

export default PartTwo;


// WEBPACK FOOTER //
// ./src/components/modals/join/part-two.js